<template>
  <v-app>
    <div id="app">
      <AppToolbar v-if="authorised" />
      <router-view class="wz-router"></router-view>
    </div>
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color">
      {{ snackbar.message }}
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import AppToolbar from './components/AppToolbar.vue'

export default {
  components: {
    AppToolbar,
  },
  computed: {
    ...mapState("whizeosupportToolsStore", ["snackbar"]),
    ...mapState("authStore", ["authorised"]),
  },
};
</script>

<style>

#app {
  font-family: semplicitapro, Arial;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}

html {
  all: initial;
}

.wz-router {
  padding-top: 100px;
}

</style>
